/**
 * Guatemalan quetzal.
 */
export var GTQ = {
  code: 'GTQ',
  base: 10,
  exponent: 2
};